import { addToast, removeToast } from '../slices/toastSlice';
import { selectToastConfig } from '../slices/toastConfigSlice';
import logger from './../../utils/logger.js';


/**
 * Custom middleware to handle toast lifecycle management
 * - Manages auto-dismissal timers
 * - Prevents duplicate toasts based on configuration
 * - Handles toast queueing if needed
 */
const toastMiddleware = store => {
  // Map to track active toast timers
  const toastTimers = new Map();

  return next => action => {
    // Handle new toast creation before passing to reducer
    if (addToast.match(action)) {
      const state = store.getState();
      const config = selectToastConfig(state);
      const toast = action.payload;
      
      // Check for duplicates if preventDuplicates is enabled
      if (config.preventDuplicates) {
        const existingToasts = state.toast.toasts;
        const isDuplicate = existingToasts.some(t => 
          t.type === toast.type && t.message === toast.message
        );
        
        // Skip adding duplicate toast
        if (isDuplicate) {
          logger.debug('Preventing duplicate toast:', toast.message);
          return {}; // Return empty object instead of the action
        }
      }
    }
    
    // Pass the action to the next middleware/reducer
    const result = next(action);
    
    // Handle post-processing after the action has been processed
    if (addToast.match(action)) {
      const toast = action.payload;
      
      // Set timer to auto-dismiss this toast
      const timerId = setTimeout(() => {
        store.dispatch(removeToast(toast.id));
      }, toast.duration);
      
      // Store timer reference for cleanup
      toastTimers.set(toast.id, timerId);
    }

    // Clean up timer when toast is removed
    if (removeToast.match(action)) {
      const toastId = action.payload;
      if (toastTimers.has(toastId)) {
        clearTimeout(toastTimers.get(toastId));
        toastTimers.delete(toastId);
      }
    }

    return result;
  };
};

export default toastMiddleware;
